export const DEFAULT_TOOLBAR_POPPER_SHOW_DELAY = 80;
export const DEFAULT_TOOLBAR_POPPER_HIDE_DELAY = 300;
